export enum OrderStatus {
    NEW = "new",
    UNDER_REVIEW = "under review",
    AWAITING_CONFIRMATION = "awaiting confirmation",
    ACTIVE = "active",
    PAUSED = "paused",
    CANCELED = "canceled",
    COMPLETED = "completed",
}
